import { UseCaseRecursoAsync } from "src/views/core/types/UseCaseRecursoAsync";
import { FechaParams } from "../../utils/params/FechaParams.params";
import { Recurso } from 'lib.common/dist/CleanArch';
import { ErrDevGenerico } from 'lib.common/dist/errorHandler';
import { ClientesSinContacto, EstadisticasCRM, EstadoProductosAnual, ResumenAtencion } from "../entities/EstadisticasCRM.entity";
import { EstadisticasCRMRepository } from "../repositories/EstadisticasCRMRepository";

export class GetEstadisticasCRMUseCase<
    T_OUT extends EstadisticasCRM,
    T_OUT2 extends ClientesSinContacto,
    T_OUT3 extends ResumenAtencion,
    T_OUT4 extends EstadoProductosAnual
> extends UseCaseRecursoAsync<
    FechaParams,
    T_OUT
> {
    private repository: EstadisticasCRMRepository<T_OUT, T_OUT2, T_OUT3, T_OUT4>;
    constructor(repository: EstadisticasCRMRepository<T_OUT, T_OUT2, T_OUT3, T_OUT4>) {
        super();
        this.repository = repository;
    }

    async call(input: FechaParams): Promise<Recurso<T_OUT>> {
        try {
            return this.repository.getEstadisticasCRM(input);
        } catch (error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT>(errorCapa);
        }
    }
}